module.exports = __webpack_public_path__ + "img/home-card-item3.d41fa019.png";